import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSwipeable } from 'react-swipeable';
import { IBindingAction } from '../../../../common/models/callback';
import LinkButton from '../../../../components/LinkButton';
import RegularButton from '../../../../components/RegularButton';
import styles from './styles.module.scss';

interface IProps {
  companyName: string;
  companyLogo: string | undefined;
  optInText: string | undefined;
  onConfirm: IBindingAction;
  onCancel: IBindingAction;
}

const ProspectIntro: FunctionComponent<IProps> = ({
  companyName,
  optInText,
  companyLogo,
  onConfirm,
  onCancel
}) => {
  const swipeHandler = useSwipeable({
    onSwipedLeft: onConfirm,
    trackMouse: false
  });

  return (
    <div {...swipeHandler} className="survey-page">
      <div className="d-flex flex-column align-items-center">
        {companyLogo && (
          <img src={companyLogo} alt="logo" className="survey-logo" />
        )}
        <p className="text-center survey-page-title mb-3">
          <FormattedMessage id="candidateForm.thank.title" defaultMessage="Thank you!" />
        </p>
        <p className="text-center survey-question-block mb-5">
          {optInText || (
            <FormattedMessage
              id="survey.prospectContact"
              defaultMessage="Are you interested in learning about career development opportunities with {companyName}?"
              values={{
                companyName
              }}
            />
          )}
        </p>
        <div className={`${styles.regularButton} mb-4`}>
          <RegularButton
            textIntlId="yes"
            defaultMessage="Yes"
            size="lg"
            onClick={onConfirm}
          />
        </div>
        <LinkButton
          textIntlId="survey.noThankYou"
          defaultMessage="No, thank you"
          variant="secondary"
          size="lg"
          onClick={onCancel}
        />
      </div>
    </div>
  );
};

export default ProspectIntro;
